import client from "../../../api/client";

export default async function getRoomListingDetails(listingId) {
    const response = await client.get(`/room-listings/${listingId}`);
    return response.data;
}